import { Grid } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import BotonComponent from '../dashboard/components/BotonNuevo';

const ResumenesView = () => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const resumenesStore = Redux.useSelector((state) => state.resumenes);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            // await setActivoResumenesAction(dispatch, null);
            // setOpenModalForm(true);
          }}
          white
          mr={2}
          text="RESUMEN FINAL 1"
        />
        <BotonComponent
          click={async () => {
            // await setActivoResumenesAction(dispatch, null);
            // setOpenModalForm(true);
          }}
          white
          mr={2}
          text="RESUMEN FINAL 2"
        />
        <BotonComponent
          click={async () => {
            // await setActivoResumenesAction(dispatch, null);
            // setOpenModalForm(true);
          }}
          white
          mr={2}
          text="RESUMEN FINAL 3"
        />
        <BotonComponent
          click={async () => {
            // await setActivoResumenesAction(dispatch, null);
            // setOpenModalForm(true);
          }}
          white
          mr={2}
          text="CERTIFICACIÓN DE NOTAS"
        />
        {/* <BotonComponent
          click={async () => {
            await setActivoResumenesAction(dispatch, null);
            await allResumenesAction(dispatch, resumenesStore.params);
          }}
          disabled={
            resumenesStore.all.length === 0 || resumenesStore.loadingAll
          }
          white
          refreshIcon
          text={resumenesStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        /> */}
      </Grid>
      {/* <Grid item md={12}>
        <CalendarioResumenesComponent setOpenModalForm={setOpenModalForm} />
      </Grid>
      <ModalComponent
        id="modalFormResumenes"
        title={`${
          resumenesStore.activo
            ? `Editar ${resumenesStore.activo.nombre}`
            : 'Nuevo reporte'
        }`}
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <FormResumenes
          activo={resumenesStore.activo}
          setOpenModalForm={(val) => setOpenModalForm(val)}
        />
      </ModalComponent> */}
    </Grid>
  );
};

export default ResumenesView;
